import { cartingStore } from "../cartingorder/cartingStore";
import { data } from "../charts/c1";
import { enquiryStore } from "../enquiry/enquiry-data";
import { SendBookingMailer } from "../pricing/pricing.screen"
import TenantUtils from "../util/tenant.utils";
import Utils from "../util/Utils";
import Api from "./Api"
import { bookingsStore, contractsStore, configStore } from "./CommonState"
const BOOKINGSURI = {
    GET4CONTRACT: (contractNum) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/contract/${contractNum}`,
    GET: (bookingNum) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/${bookingNum}`,
    GET_FOR_CONSOLE: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/planning`,
    BOOKING_WITH_ENTITIE: (bookingNum) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/withentities/${bookingNum}`,
    GETALL: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings`,
    GETALLBOOKINGS: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/getallbookings`,
    SAVE_INVOICE_DETAILS: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/saveInvoice`,
    POST: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings`,
    UPDATE_PLANNING_STATUS: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/updatePlanning`,
    GET_CONTAINERS: (containerStatus, page, get) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/container/${containerStatus}/${page}/${get}`,
    GET_CONTAINER_LIST: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/container/getall`,
    UPDATE_CONTAINER: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/container`,
    CANCEL_BOOKING: (id) =>  `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/cancelBooking/${id}`,
    SETCUSTREF_BOOKING: (id) =>  `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/setCustref/${id}`,
    SETFBADETAILS_BOOKING: (id) =>  `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/setFbadetails/${id}`,
    SETINTERNALLIST_BOOKING: (id) =>  `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/setInternalList/${id}`,
    SETAGENTENTITYID_BOOKING: (id) =>  `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/setAgentEntityId/${id}`,
    SENDLINK : (id)=>`${process.env.REACT_APP_API_SERVER}/api/v1/trackmybookings/sharebooking/${id}`,
    DOWNLOAD_STUFFING_SHEET: (consoleId) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/downloadStuffingSheet/${consoleId}`,
    CARGO_FOR_CONSOLE: (consoleId) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/cargo-for-console/${consoleId}`,
    DOWNLOAD_BL: (id) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/downloadBL/${id}`,
    REPROCESS_BL: (bookingNumber) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/reprocess-bl/${bookingNumber}`,
    RESEND_BL: (bookingNumber) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/resend-bl/${bookingNumber}`,
    DELETE_INTAKE_EMAIL: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/delete-intake-email`,
    MARK_BL_FAILED: (bookingNumber) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/mark-bl-failed/${bookingNumber}`,
    RESOLVE_CASE: (bookingNumber) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/resolve-case/${bookingNumber}`,
    UPDATE_BL_FIELDS: (bookingNumber) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/update-bl-fields/${bookingNumber}`,
    BL_AUTOMATION_REPORT: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/bl-automation-report`,
}
export default class BookingsApi {
    static getAllBookings(callback = f => f) {
        // Api.fetch(BOOKINGSURI.GETALL, (data) => {
        //     bookingsStore.list = data
        //     callback(data)
        // })
    }
static async downloadStuffingSheet(consoleId) {
  const url = BOOKINGSURI.DOWNLOAD_STUFFING_SHEET(consoleId);

  try {
    const res = await fetch(url, {
      headers: Api.H(),
      credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
    });

    if (!res.ok) throw new Error(`Download failed: ${res.status}`);

    const data = await res.json();

    const blob = Utils.b64toBlob(data.base64, data.mimeType);

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = data.fileName;
    link.click();
    URL.revokeObjectURL(link.href);

    return true;

  } catch (err) {
    console.error('Download error:', err);
    configStore.setModalMessage(err?.message || 'Failed to download stuffing sheet');
    return false;
  }
}

static async getCargoForConsole(consoleId) {
    const url = BOOKINGSURI.CARGO_FOR_CONSOLE(consoleId)
    const res = await fetch(url, {
        headers: Api.H(),
        credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
    })
    if (!res.ok) throw new Error(`Failed to fetch cargo: ${res.status}`)
    return res.json()
}

static async printBL(id) {
  const url = BOOKINGSURI.DOWNLOAD_BL(id);

  try {
    const res = await fetch(url, {
      headers: Api.H(),
      credentials: Utils.shouldSendCredentials(url) ? "include" : "omit",
    });

    if (!res.ok) {
      throw new Error(`Download failed: ${res.status}`);
    }
    const blob = await res.blob();

    const contentDisposition = res.headers.get("content-disposition");
    let fileName = "BL.pdf";

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?(.+)"?/);
      if (match?.[1]) {
        fileName = match[1];
      }
    }

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    URL.revokeObjectURL(link.href);
    link.remove();

    return true;

  } catch (err) {
    console.error("Download error:", err);
    configStore.setModalMessage(
      err?.message || "Failed to download BL PDF"
    );
    return false;
  }
}

static async reprocessBL(bookingNumber, payload = {}, callback) {
  Api.post(
    BOOKINGSURI.REPROCESS_BL(bookingNumber),
    payload,
    (data) => {
      if (callback) callback(data);
    },
    (err) => {
      if (callback) callback({ success: false, message: typeof err === 'string' ? err : 'Reprocessing request failed' });
    }
  );
}

static async updateBLMandatoryFields(bookingNumber, payload = {}, callback) {
  Api.post(
    BOOKINGSURI.UPDATE_BL_FIELDS(bookingNumber),
    payload,
    (data) => {
      if (callback) callback(data);
    },
    (err) => {
      if (callback) callback({ success: false, message: typeof err === 'string' ? err : 'Updating BL fields failed' });
    }
  );
}

static async resendBL(bookingNumber, payload = {}, callback) {
  Api.post(
    BOOKINGSURI.RESEND_BL(bookingNumber),
    payload,
    (data) => {
      if (callback) callback(data);
    },
    (err) => {
      if (callback) callback({ success: false, message: typeof err === 'string' ? err : 'Resend BL request failed' });
    }
  );
}

static async deleteIntakeEmail(messageId, callback) {
  Api.post(
    BOOKINGSURI.DELETE_INTAKE_EMAIL,
    { messageId },
    (data) => {
      if (callback) callback(data);
    },
    (err) => {
      if (callback) callback({ success: false, message: typeof err === 'string' ? err : 'Delete email intake failed' });
    }
  );
}

static async markBLFailed(bookingNumber, payload = {}, callback) {
  Api.post(
    BOOKINGSURI.MARK_BL_FAILED(bookingNumber),
    payload,
    (data) => {
      if (callback) callback(data);
    },
    (err) => {
      if (callback) callback({ success: false, message: typeof err === 'string' ? err : 'Mark failed request failed' });
    }
  );
}

static async resolveCase(bookingNumber, payload = {}, callback) {
  Api.post(
    BOOKINGSURI.RESOLVE_CASE(bookingNumber),
    payload,
    (data) => {
      if (callback) callback(data);
    },
    (err) => {
      if (callback) callback({ success: false, message: typeof err === 'string' ? err : 'Resolve case request failed' });
    }
  );
}

static getBLAutomationReport(params = {}, callback, errcallback) {
  const queryParts = [];
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
    }
  });
  const queryString = queryParts.length > 0 ? `?${queryParts.join('&')}` : '';
  const url = `${BOOKINGSURI.BL_AUTOMATION_REPORT}${queryString}`;
  Api.fetch(url, (data) => {
    if (callback) callback(data);
  }, errcallback);
}



    static getAllBookingsNew(BkNumdata ,callback = f => f) {
        Api.post(BOOKINGSURI.GETALLBOOKINGS , BkNumdata ,  (data) => {
            callback(data)
        })
    }

    static sendTrackBookingLink(bookingDetail){
        const {id,...reqBody} = bookingDetail;
        Api.post(BOOKINGSURI.SENDLINK(id),reqBody);
    }

    static getBookingWithEntitie(bookingNum, callback = f => f) {
        Api.fetch(BOOKINGSURI.BOOKING_WITH_ENTITIE(bookingNum), (data) => {
            callback(data)
        })
    }

    static getBookingsForConsole(details, callback = f => f) {
        Api.post(BOOKINGSURI.GET_FOR_CONSOLE, details, (data) => {
            callback(data)
        })
    }
   static updatePlanningStatus(details, callback) {
        return new Promise((resolve) => {
            Api.put(BOOKINGSURI.UPDATE_PLANNING_STATUS, details, (res) => {
                if (callback) {
                    callback(res);
                }
                if (res?.Success) {
                    configStore.setModalMessage(`${details?.planningStatus === 'image' ? `Images saved` : `Shipment status moved`}`);
                } else {
                    configStore.setModalMessage(`${res?.message || 'Unknown error'}`);
                }
                resolve(res);
            }, (err) => {
                if (callback) callback(err);
                resolve({ Success: false, error: err });
            });
        });
    }
   static updateContainer(details, callback) {
    Api.put(BOOKINGSURI.UPDATE_CONTAINER, details, (response) => {
        if (response?.message) {
            configStore.setModalMessage(response.message);
        } else {
            configStore.setModalMessage(`Container ${details._id} updated successfully`);
        }

        if (callback) {
            callback(response);
        }
    });
}

       static getContainers(containerStatus, page, get, callback = f => f) {
        console.log("Fetching containers for status:", containerStatus, "Page:", page);
        
        Api.fetch(BOOKINGSURI.GET_CONTAINERS(containerStatus, page, get), (data) => {
            console.log("Received container data:", data);
            
            callback(data)
        })
    }
    static getContainerList( callback = f => f) {
        
        Api.fetch(BOOKINGSURI.GET_CONTAINER_LIST, (data) => {
            callback(data)
        })
    }


    static getBooking(bookingNum, callback = f => f) {
        Api.fetch(BOOKINGSURI.GET(bookingNum), (data) => {
            let stype = data.contract.shipmentType.substr(0, 3).toLowerCase()
            if(stype=='air'){
                if(data.contract.airline != undefined && data.contract.airline.trim().length==0 && data.airline != undefined && data.airline.trim().length!=0){
                    data.contract.airline = data.airline
                }
            }
            bookingsStore.current = data
            callback(data)
        })
    }

    static getForContract(contractNum, callback = f => f) {
        Api.fetch(BOOKINGSURI.GET4CONTRACT(contractNum), (data) => {
            bookingsStore.list = data
            callback(data)
        })
    }
    
    static saveBooking(shipperConsignee,callback,booking = (f) => f,errCallback) {
        const getcharge = (d,b)=>{
            let a = {}
            let l = []
            for (let i = 0; i < b.contract.chargesList.length; i++) {
                let c = b.contract.chargesList[i]
                const k = (c,a) =>{
                    a[c["chargeDescription"]] = {}
                    let o = Object.keys(c)
                    o = o.filter(item => !["chargeDescription","onaccount","isIncluded"].includes(item))
                    for (let j = 0; j < o.length; j++) {
                        a[c["chargeDescription"]][o[j]] = c[o[j]]
                    }
                    return a
                }
                if(c["onaccount"]==undefined && d=="On Your Account"){
                    a = k(c,a)
                    l.push(c)
                }
                if(c["onaccount"]!=undefined && c["onaccount"]==d){
                    a = k(c,a)
                    l.push(c)
                }
            }
            return {"charge":a,"list":l}
        }
        if (TenantUtils.isNavexel() && bookingsStore.current.contract.nomination === undefined) {
            if(cartingStore.current._id!=undefined && cartingStore.current._id.length>0){
            bookingsStore.current.contract.nomination = cartingStore.current.nomination
            }else {
            bookingsStore.current.contract.nomination = enquiryStore.current.nomination
            }

        }
        let b = {bookingData:bookingsStore.current, shipperConsignee: shipperConsignee}
        if(b.bookingData.isPershipmentcharge!=undefined && b.bookingData.isPershipmentcharge && b.bookingData.contract.shipmentType.indexOf("LCL") >= 0){

                const setperShipment = (list)=>{
                    let l = []
                    if(list!=undefined && list.length>0){
                        for (let i = 0; i < list.length; i++) {
                            let z = list[i]
                            z['maximum'] = 0
                            z['minimum'] = 0
                            z['perCBM'] = 0
                            z['perTon'] = 0
                            z['perShipment'] = z['total']
                            l.push(z)
                        }
                    }
                    return l
                }
                b.bookingData.contract.shipperchargesList = setperShipment(b.bookingData.contract.shipperchargesList)
                b.bookingData.contract.consigneechargesList = setperShipment(b.bookingData.contract.consigneechargesList)
                b.bookingData.contract.chargesList = setperShipment(b.bookingData.contract.chargesList)
            
        }
         
        if(b.createdFromPricing!=undefined && b.createdFromPricing){
            if(b.contract.shippercharges==undefined){
                let k = getcharge("Shipper's Account",b)
                if(Object.keys(k["charge"]).length>0){
                    b.contract.shippercharges = k["charge"]
                }
                if(k["list"].length>0){
                    b.contract.shipperchargesList = k["list"]
                }
            }
            if(b.contract.consigneecharges==undefined){
                let k = getcharge("Consignee's Account",b)
                if(Object.keys(k["charge"]).length>0){
                    b.contract.consigneecharges = k["charge"]
                }
                if(k["list"].length>0){
                    b.contract.consigneechargesList = k["list"]
                }
            }
            if(b.contract.charges==undefined){
                let k = getcharge("On Your Account",b)
                if(Object.keys(k["charge"]).length>0){
                    b.contract.charges = k["charge"]
                }
                if(k["list"].length>0){
                    b.contract.chargesList = k["list"]
                }
            }
        }
        console.log(" the b of the booking is ",b)
        // return
        Api.post(BOOKINGSURI.POST, b, (data) => {
            //if (fromPricing) SendBookingMailer(data)
            booking(data)
            configStore.setBookingModalMessage(data._id)
            callback(data)
        },errCallback)
    }

    static cancelBooking(bookingNum,reason,callback) {
        Api.put(BOOKINGSURI.CANCEL_BOOKING(bookingNum),{ reason },() => {
            // configStore.setModalMessage(`Booking ${bookingNum} Cancelled`)
            if(callback){
                callback();
            }
            configStore.setModalMessage(`Booking Cancellation request placed successfully`)
        } )
    }

    static cancelBookingfromqoute(bookingNum,reason) {
        Api.put(BOOKINGSURI.CANCEL_BOOKING(bookingNum),{ reason },() => {
            // configStore.setModalMessage(`Booking ${bookingNum} Cancelled`)
        } )
    }

    static setcustrefBooking(bookingNum,contract) {
        Api.put(BOOKINGSURI.SETCUSTREF_BOOKING(bookingNum),{ contract },() => {
            configStore.setModalMessage(`Booking ${bookingNum} - Cust Ref Changed.`)
        } )
    }

    static setAgentDetails(bookingNum,contract){
         Api.put(BOOKINGSURI.SETCUSTREF_BOOKING(bookingNum),{ contract },() => {
             BookingsApi.setAgentEntityId(bookingNum,contract.agentEntityId,()=>{
                 configStore.setModalMessage(`Booking ${bookingNum} - Agent Detail updated Changed.`)
             })
        } )
    }

    static setAgentEntityId(bookingNum,agentEntityId,callback){
        Api.put(BOOKINGSURI.SETAGENTENTITYID_BOOKING(bookingNum),{agentEntityId},callback)
    }

    static setfbadetailsBooking(bookingNum,fbaDetails,merchantID,msg=true,callback) {
        Api.put(BOOKINGSURI.SETFBADETAILS_BOOKING(bookingNum),{ fbaDetails:fbaDetails,merchantID:merchantID },() => {
            if(msg){
                configStore.setModalMessage(`Booking ${bookingNum} - FBA Details Changed.`)
            }
            if(callback){
                callback()
            }
        } )
    }
    static setInternalList(bookingNum,internallist,msg=true,callback) {
        Api.put(BOOKINGSURI.SETINTERNALLIST_BOOKING(bookingNum),{ internallist:internallist },() => {
            if(msg){
                configStore.setModalMessage(`Booking ${bookingNum} - Internal Details Changed.`)
            }
            if(callback){
                callback()
            }
        } )
    }
  static saveInvoiceDetails(bookingNum, invoiceDetails) {
  return new Promise((resolve, reject) => {
    Api.post(
      BOOKINGSURI.SAVE_INVOICE_DETAILS,
      { bookingNum, invoiceDetails },
      (data) => {
        if (data?.success === false) {
          reject(data);
        } else {
          resolve(data);
        }
      }
    );
  });
}

}